var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJoin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.329,
    height: 40.3,
    viewBox: "0 0 45.329 40.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_52",
    "data-name": "Group 52",
    transform: "translate(-1043.065 -383.85)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_118",
    "data-name": "Group 118",
    transform: "translate(1045.276 384.798)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_5861230_communication_connect_join_online_social_icon",
    "data-name": "5861230_communication_connect_join_online_social_icon",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_170",
    "data-name": "Path 170",
    d: "M32.6,28.071l.8,1.385a5.6,5.6,0,1,0-5.9-.184l.886-1.333a4,4,0,1,1,4.212.132Z",
    transform: "translate(-11.391 -6.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_171",
    "data-name": "Path 171",
    d: "M19,23.4a10.391,10.391,0,0,0,4.649,8.678l.886-1.333a8.805,8.805,0,1,1,9.737,0l.886,1.333A10.406,10.406,0,1,0,19,23.4Z",
    transform: "translate(-10.193 -4.992)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_172",
    "data-name": "Path 172",
    d: "M53.5,26.583c0-.561-.025-1.124-.074-1.671l-1.593.136c.045.5.067,1.015.067,1.53A17.521,17.521,0,0,1,43.477,41.61l.838,1.365A19.111,19.111,0,0,0,53.5,26.583Z",
    transform: "translate(-15.078 -7.37)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    d: "M30.334,4.6a17.479,17.479,0,0,1,9.918,3.062l.9-1.32a19.216,19.216,0,0,0-17.5-2.149l.556,1.5A17.566,17.566,0,0,1,30.334,4.6Z",
    transform: "translate(-11.121 -2.999)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    d: "M9.2,18.652a19.234,19.234,0,0,0,7.992,23.072l.837-1.365A17.633,17.633,0,0,1,10.7,19.208Z",
    transform: "translate(-7.999 -6.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    y2: 6.199,
    transform: "translate(19.212 18.541)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M251.957,354.074a3.353,3.353,0,1,0-3.849,0,5.872,5.872,0,0,0-3.938,5.536.47.47,0,0,0,.94,0,4.926,4.926,0,1,1,9.852,0,.47.47,0,0,0,.94,0A6.508,6.508,0,0,0,251.957,354.074Zm-4.338-2.742a2.416,2.416,0,1,1,2.417,2.416,2.416,2.416,0,0,1-2.417-2.416Z",
    transform: "translate(799.045 36.025)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107-2",
    "data-name": "Path 107",
    d: "M251.957,354.074a3.353,3.353,0,1,0-3.849,0,5.872,5.872,0,0,0-3.938,5.536.47.47,0,0,0,.94,0,4.926,4.926,0,1,1,9.852,0,.47.47,0,0,0,.94,0A6.508,6.508,0,0,0,251.957,354.074Zm-4.338-2.742a2.416,2.416,0,1,1,2.417,2.416,2.416,2.416,0,0,1-2.417-2.416Z",
    transform: "translate(832.343 40.674)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107-3",
    "data-name": "Path 107",
    d: "M251.957,354.074a3.353,3.353,0,1,0-3.849,0,5.872,5.872,0,0,0-3.938,5.536.47.47,0,0,0,.94,0,4.926,4.926,0,1,1,9.852,0,.47.47,0,0,0,.94,0A6.508,6.508,0,0,0,251.957,354.074Zm-4.338-2.742a2.416,2.416,0,1,1,2.417,2.416,2.416,2.416,0,0,1-2.417-2.416Z",
    transform: "translate(814.452 63.92)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJoin);
export default __webpack_public_path__ + "static/media/join.43e5dd60f3a21e5c049a8f6c00035164.svg";
export { ForwardRef as ReactComponent };